<template>
    <!-- <apexchart id="apexchart" :options="chartOptions" :series="series" type="bar" height="450"/> -->
    <v-container fluid pa-0>
        <progress-overlay :Loading="Loading"></progress-overlay>
        <v-card class="ma-0 pa-0 chartCard" style="min-height:100%">
            <!--<v-card-title>-->
            <v-toolbar color="transparent" flat dense class="chartCardHeader">
                <v-toolbar-title><h4>{{QuestionList.compositeText}}</h4></v-toolbar-title>
                    <v-spacer></v-spacer>
                    <DataCountInfo :dataCountInfo="dataCountInfo.yourDataCount"
                                   :dataInfoName="yourDataDataInfoName" class="dataCountInfoChip"></DataCountInfo>
                    <DataCountInfo :dataCountInfo="dataCountInfo.benchmarkDataCount"
                                   :dataInfoName="benchmarkDataInfoName" class="dataCountInfoChip"></DataCountInfo>
                    <v-btn @click="$emit('next')" dark color="#666666" small>Next<v-icon right>navigate_next</v-icon></v-btn>
                    <!--</v-card-title>-->
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text>
                <v-layout row wrap>
                    <v-flex xs6 class="ma-1 pa-1 pl-3">
                        <v-radio-group v-model="modelScoreRadios" row hide-details class="segmentationRadio">
                            <template v-slot:label>
                                <div class="subheading font-weight-bold">Score View:</div>
                            </template>
                            <v-radio value="scaledMeanScore" label="Scaled Mean Score" @change="updateChart('scaledMeanScore')">
                            </v-radio>
                            <v-radio value="summaryRateScore" label="Summary Rate Score" @change="updateChart('summaryRateScore')">
                            </v-radio>
                            <v-radio value="topBoxScore" label="Top Box Score" @change="updateChart('topBoxScore')">
                            </v-radio>
                        </v-radio-group>
                    </v-flex>
                    <v-flex xs6 v-if="QuestionList.questionData && QuestionList.questionData.length > 1" class="ma-0 pa-0 pl-3">
                        <v-radio-group v-model="modelQuestionRadios" row class="segmentationRadio">
                            <template v-slot:label>
                                <div class="subheading font-weight-bold">Graph View:</div>
                            </template>
                            <v-radio label="Composite"
                                        value="CompositeQuestion"
                                        @change="updateChartByQuestion('CompositeQuestion')">
                            </v-radio>
                            <v-radio v-for="(question, index) in QuestionList.questionData"
                                        :label="question.questionNum"
                                        :value="question.questionNum"
                                        v-bind:key="index"
                                        @change="updateChartByQuestion(question.questionNum)">
                            </v-radio>
                        </v-radio-group>
                    </v-flex>
                    <v-flex xs8 class="ma-0 pa-0 barChartBorder">
                        <bar-chart-horizontal ref="SurveyDataBarChart"
                                              :chart-data="chartData"
                                              id="SurveyDataBarChart"
                                              style="position: relative; height:auto; width:50vw"></bar-chart-horizontal>
                    </v-flex>
                    <v-flex xs4 class="ma-0 pa-0 pl-1 questionCard">
                        <v-card v-if="QuestionList.questionData">
                            <v-card-title>
                                <div>
                                    <div class="text-md-left font-weight-bold questionCard">{{QuestionList.compositeDesc}}</div>
                                </div>
                            </v-card-title>
                            <v-card-text>
                                <div v-for="(question, index) in QuestionList.questionData" v-bind:key="index" class="questionCard">
                                    {{question.questionText}}
                                    <br />
                                    <br />
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 class="categoriesDataSourceLabel">
                        <FilterSelections :tblDataFilters="tblYourDataFilters"
                                            :heading="nameDataSource"></FilterSelections>
                    </v-flex>
                    <v-flex xs12 class="categoriesDataSourceLabel">
                        <FilterSelections :tblDataFilters="tblBenchmarkFilters"
                                            :heading="nameBenchmark"></FilterSelections>
                    </v-flex>
                    <v-flex v-if="Tab.payload==2" xs12 class="categoriesDataSourceLabel">
                        <FilterSelections :tblDataFilters="tblSegmentFilters"
                                            :heading="nameSegment"></FilterSelections>
                    </v-flex>
                    <v-flex v-if="Tab.payload==3" xs12 class="categoriesDataSourceLabel">
                        <FilterSelections :tblDataFilters="tblCohortFilters"
                                            :heading="nameCohort"></FilterSelections>
                    </v-flex>
                    <v-flex v-if="Tab.payload==3" xs12 class="categoriesDataSourceLabel">
                        <CohortFilterSelections :tblDataFilters="tblCohortListFilters"
                                                :heading="nameCohort"></CohortFilterSelections>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>
    import { mapState, mapActions } from 'vuex';
    import BarChartHorizontalConfig from "./BarChartHorizontalConfig";
    import ProgressOverlay from '../_partial/ProgressOverlay'
    import DataCountInfo from '../_partial/DataCountInfo'
    import FilterSelections from '../_partial/FilterSelections'
    import CohortFilterSelections from '../_partial/CohortFilterSelections'

    export default {
        components: {
            "bar-chart-horizontal": BarChartHorizontalConfig,
            ProgressOverlay,
            DataCountInfo,
            FilterSelections,
            CohortFilterSelections
        },
        data() {
            return {
                Loading: false,
                nameDataSource: "Data Source:",
                nameBenchmark: "Benchmark:",
                nameSegment: "Segmentation:",
                nameCohort: "Cohorts:",
                yourDataDataInfoName: "Your Data:",
                benchmarkDataInfoName: "Benchmark Data:"
            }
        },
        computed: {
            ...mapState({
                chartData: state => state.SegmentMeasureStore.chartData,
                QuestionList: state => state.SegmentMeasureStore.QuestionList,
                Tab: state => state.AppStore.tab,
                tblYourDataFilters: state => state.CategoriesStore.tblYourDataFilters,
                tblBenchmarkFilters: state => state.CategoriesStore.tblBenchmarkFilters,
                tblSegmentFilters: state => state.CategoriesStore.tblSegmentFilters,
                tblCohortFilters: state => state.CategoriesStore.tblCohortFilters,
                dataCountInfo: state => state.YourDataStore.dataCountInfo,
                tblCohortListFilters: state => state.UserSettingStore.tblCohortListFilters,
            }),
            CategoriesSelectedYourData: {
                get() {
                    return this.$store.getters['CategoriesStore/selectedCategoriesYourDataNames']
                }
            },
            CategoriesSelectedBenchmark: {
                get() {
                    return this.$store.getters['CategoriesStore/selectedCategoriesBenchmarkNames']
                }
            },
            CategoriesSelectedSegment: {
                get() {
                    return this.$store.getters['CategoriesStore/selectedCategoriesSegmentNames']
                }
            },
            modelScoreRadios: {
                get() {
                    return this.$store.state.YourDataStore.modelScoreRadios;
                },
                set(newVal) {
                    this.$store.state.YourDataStore.modelScoreRadios = newVal;
                }
            },
            modelQuestionRadios: {
                get() {
                    return this.$store.state.SegmentMeasureStore.modelQuestionRadios;
                },
                set(newVal) {
                    this.$store.state.SegmentMeasureStore.modelQuestionRadios = newVal;
                }
            }
        },
        methods: {
            ...mapActions('SegmentMeasureStore', [
                'updateChart',
                'updateChartByQuestion'
            ]),
            clearAllYourDataFilters() {
                this.filtersUpdated = false;
                this.$store.dispatch('CategoriesStore/resetYourDataFilters')
                this.Loading = true;
                this.$store.dispatch('SegmentMeasureStore/getClientDataWithSegmentation')
                    .then(() => {
                        this.Loading = false;
                    }).catch(error => {
                        this.Loading = false;
                        this.$store.dispatch('AppStore/SetAlert', { alert: error, isError: true })
                    })
            },
            clearAllBenchmarkFilters() {
                this.filtersUpdated = false;
                this.$store.dispatch('CategoriesStore/resetBenchmarkFilters')
                this.Loading = true;
                this.$store.dispatch('SegmentMeasureStore/getClientDataWithSegmentation')
                    .then(() => {
                        this.Loading = false;
                    }).catch(error => {
                        this.Loading = false;
                        this.$store.dispatch('AppStore/SetAlert', { alert: error, isError: true })
                    })
            },
            clearAllSegmentFilters() {
                this.filtersUpdated = false;
                this.$store.dispatch('CategoriesStore/resetSegmentFilters')
                this.Loading = true;
                this.$store.dispatch('SegmentMeasureStore/resetCompositeQuestionText')
                    .then(() => {
                        this.Loading = false;
                    }).catch(error => {
                        this.Loading = false;
                        this.$store.dispatch('AppStore/SetAlert', { alert: error, isError: true })
                    })
                this.$store.dispatch('SegmentMeasureStore/getClientDataWithSegmentation')
                    .then(() => {
                        this.Loading = false;
                    }).catch(error => {
                        this.Loading = false;
                        this.$store.dispatch('AppStore/SetAlert', { alert: error, isError: true })
                    })
            },
        },
        mounted() {
            var tabName = '';
            if (this.Tab.payload == 2) {
                tabName = 'segment'
            }
            else if (this.Tab.payload == 3) {
                tabName = 'cohort'
            }

            this.$store.dispatch('CategoriesStore/getAllCategories', tabName)
                .then(() => {
                    if (this.Tab.payload == 3) { //cohort
                        this.$store.dispatch('SegmentMeasureStore/getCompositeQuestionTextForCohort')
                            .then(() => {
                            }).catch(error => {
                                this.Loading = false;
                                this.$store.dispatch('SegmentMeasureStore/resetCompositeQuestionText')
                                this.$store.dispatch('AppStore/SetAlert', { alert: error, isError: true })
                            });
                        this.Loading = true;
                        this.$store.dispatch('SegmentMeasureStore/GetClientDataWithCohort')
                            .then(() => {
                                this.Loading = false;
                            }).catch(error => {
                                this.Loading = false;
                                this.$store.dispatch('AppStore/SetAlert', { alert: error, isError: true })
                            });
                    }
                    else { //segment
                        this.$store.dispatch('SegmentMeasureStore/getCompositeQuestionText')
                            .then(() => {
                            }).catch(error => {
                                this.Loading = false;
                                this.$store.dispatch('SegmentMeasureStore/resetCompositeQuestionText')
                                this.$store.dispatch('AppStore/SetAlert', { alert: error, isError: true })
                            });
                        this.Loading = true;
                        this.$store.dispatch('SegmentMeasureStore/getClientDataWithSegmentation')
                            .then(() => {
                                this.Loading = false;
                            }).catch(error => {
                                this.Loading = false;
                                this.$store.dispatch('AppStore/SetAlert', { alert: error, isError: true })
                            });
                    }
                })
                .catch(error => {
                    this.Loading = false;
                    this.$store.dispatch('AppStore/SetAlert', { alert: error, isError: true })
                    console.log(error);
                });

           
        }
    };
</script>
<style scoped>
    .chart-container {
        position: relative;
        margin: auto;
        height: 80vh;
        width: 80vw;
    }

    .word-wrap {
        word-wrap: break-word;
    }
</style>